import React from "react";
import { Alert } from "@mui/material";

interface ReviewsErrorStateProps {
  error: string;
}

const ReviewsErrorState: React.FC<ReviewsErrorStateProps> = ({ error }) => (
  <Alert severity="error" sx={{ mb: 3 }}>
    {error}
  </Alert>
);

export default ReviewsErrorState;